import { type ValidationResult } from './model/validate';

/** File-level problems: an unreadable file, or unknown columns (which are ignored). */
export const FileProblems = ({ result }: { result: ValidationResult }) => {
  if (result.structuralErrors.length > 0) {
    return (
      <div className="rounded-lg border border-red-200 bg-red-50 p-4 dark:border-red-500/30 dark:bg-red-500/10">
        {result.structuralErrors.map((error) => (
          <p key={error.message} className="text-sm text-red-800 dark:text-red-200">
            {error.message}
          </p>
        ))}
      </div>
    );
  }
  if (result.unknownColumns.length === 0) {
    return null;
  }
  return (
    <p className="text-xs text-neutral-500 dark:text-neutral-400">
      Ignoring {result.unknownColumns.length === 1 ? 'a column' : 'columns'} not in the template:{' '}
      {result.unknownColumns.join(', ')}
    </p>
  );
};
